/**
 * Background color mapping for MediaTextCard component
 * Maps backgroundColor values from MediaCard to MUI theme colors
 */
const bgColorMap: Record<string, string> = {
  White: "common.white",
  Blue: "primary.main",
  Gray: "background.warm_strong",
  "Light Blue": "background.cool_strong",
  Transparent: "transparent",
  "background.default": "background.default",
  "background.cool": "background.cool",
  "background.cool_strong": "background.cool_strong",
  "background.warm": "background.warm",
  "background.warm_strong": "background.warm_strong",
  "background.brand": "background.brand",
  "background.brand_subtle": "background.brand_subtle"
};

export default bgColorMap;
